
import { checkoutAnswerStore, checkoutStore, mainStore } from '@/store';
import _ from 'lodash';
import { Component, Vue } from 'vue-property-decorator';
import DateComponent from '@/components/DateComponent.vue';

@Component({
  components: { DateComponent },
})
export default class List extends Vue {
  public checkoutForms: any = {};
  public valid = true;
  public isLoading = false;
  public answer = [{ value: 'ACM' }, { value: 'Lona' }];

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }

  get isPhenom() {
    return this.currentUser?.franchising_id === 1069;
  }

  get master() {
    return this.isPhenom ? 'Phenom' : 'KNN';
  }

  get currentUser() {
    return mainStore.userProfile;
  }

  public allRules(item) {
    if ([1, 2, 7].includes(item)) {
      return [(v: any) => !!v || 'Campo obrigatório'];
    }
  }

  public async submitForm(checkoutId, form) {
    const payload: any = {
      user_id: this.currentUser!.id,
    };
    const answers: any = {};
    if (!form.answer_id) {
      _.forIn(form.questions_answers, (v, _idx) => {
        answers[`${v.question_id}`] = v.answer;
      });
      payload.answers = answers;
      payload.checkout_id = checkoutId;
      payload.company_id = this.currentUser!.company_id;
      await checkoutAnswerStore.createCheckoutAnswer(payload);
    } else {
      _.forIn(form.questions_answers, (v, _idx) => {
        answers[`${v.question_id}`] = {
          checkout_answer_question_id: v.checkout_answer_question_id,
          answer: v.answer,
        };

        payload.answers = answers;
        payload.id = form.answer_id;
      });
      await checkoutAnswerStore.updateCheckoutAnswer(payload);
    }
    setTimeout(() => {
      this.$router.push('/main/profile/view');
    }, 1000);
  }

  async mounted() {
    this.isLoading = true;
    this.checkoutForms = await checkoutStore.getCheckoutsByFilter({
      checkout_id: 187,
      company_id: this.currentUser?.company_id,
    });
    this.isLoading = false;

    setTimeout(() => {
      const formCard: any = this.$refs.formCard;
      formCard.$el.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 1000);
  }
}
